namespace Matrix.Administration {
    export namespace PermissionSetPermissionService {
        export const baseUrl = 'Administration/PermissionSetPermission';

        export declare function Update(request: PermissionSetPermissionUpdateRequest, onSuccess?: (response: Serenity.ServiceResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: PermissionSetPermissionListRequest, onSuccess?: (response: Serenity.ListResponse<string>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function GetMatchingPermissionKeys(request: GetMatchingPermissionKeysRequest, onSuccess?: (response: PermissionListResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Update = "Administration/PermissionSetPermission/Update",
            List = "Administration/PermissionSetPermission/List",
            GetMatchingPermissionKeys = "Administration/PermissionSetPermission/GetMatchingPermissionKeys"
        }

        [
            'Update', 
            'List', 
            'GetMatchingPermissionKeys'
        ].forEach(x => {
            (<any>PermissionSetPermissionService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
